<template>
  <div>
    <buttonlist ref="SetBtn" @help="help" @reflash="reflash" @search="search" @save="save" ></buttonlist>
    <ul class="Boxs" ref="Box" :style="{ height: tableHeight - 90 + 'px' }">
      <li class="left" ref="left" style="width: 15%">
        <el-table :data="dataNode"
                  :height="tableHeight - 90"
                  header-row-class-name="headerclass"
                  :show-header="false"
                  border size="mini"
                  style="width: 100%; margin-top:0px"
                  :header-cell-style="$limits.headerClass"
                  @row-click="getDetail"
                  :highlight-current-row="true"
        >

          <el-table-column show-overflow-tooltip prop="name" label="部门名称"></el-table-column>
        </el-table>
      </li>

      <li class="resize" ref="resize">
        <i class="el-icon-caret-right" @click="leftt(0)"></i>
        <i class="el-icon-caret-left" @click="leftt(1)"></i>
      </li>

      <li class="mid" ref="mid" style="width: 85%; margin-left: 3px">
        <div class="btnnowrap">
          <el-button type="primary" size="mini" @click="edit" :disabled="selectData.length != 1">{{$t('getapi[34]')}}</el-button>
          <!--<el-button type="primary" size="mini" @click="batchDel" :disabled="selectData.length != 1">{{$t('getapi[4411]')}}</el-button>-->
        </div>
        <el-table
                id="xpane-0"
                ref="tree"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight - 120"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
                @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" ></el-table-column>
          <el-table-column show-overflow-tooltip prop="usernum" :label="$t('getapi[3223]')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="usercode" :label="$t('getapi[3224]')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="userid" :label="$t('getapi[3225]')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="username" :label="$t('getapi[3226]')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="loginpassword" :label="$t('getapi[3227]')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="deptname" :label="$t('getapi[3151]')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="postname" :label="$t('getapi[3228]')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="login_limit" :label="$t('getapi[3229]')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="remarks" :label="$t('getapi[143]')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="freeze_flag" :label="$t('getapi[6072]')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="inner_flag" :label="$t('getapi[6073]')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="leave_flag" :label="$t('getapi[12368]')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="tlevel"></el-table-column>
          <el-table-column show-overflow-tooltip prop="cpuid" label="ID"></el-table-column>
        </el-table>
      </li>
    </ul>

    <el-dialog v-dialogDrag :visible.sync="isShowDetail" width="50%" top="50px" @close="isShowDetail = false">
      <div style="width:100%;margin-top: 30px">
        <div style="width:100%;display: flex;">
          <div style="width:30%">
            <div>
              <div  style="height:300px">
                <el-divider content-position="left">{{$t('getapi[3543]')}}</el-divider>
                <table>
                  <tr>
                    <td>{{$t('getapi[3201]')}}</td>
                    <td>
                      <el-input v-model="dataDetail.username" type="text" size="mini" :disabled="true"></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td>{{$t('getapi[3151]')}}</td>
                    <td>
                      <el-input v-model="dataDetail.deptname" type="text" size="mini" :disabled="true"></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td>{{$t('getapi[3165]')}}</td>
                    <td>
                      <el-input v-model="dataDetail.postname" type="text" size="mini" :disabled="true"></el-input>
                    </td>
                  </tr>
                </table>
              </div>
              <div>
                <div>
                  <el-divider content-position="left">{{$t('getapi[3546]')}}</el-divider>
                  <div style="height:340px">
                    <div>
                      <el-button type="text" size="small" @click="showRole">{{
                        $t('getapi[3553]') }}
                      </el-button>
                      <el-button type="text" size="small" @click="deleteRole">{{
                        $t('getapi[3554]') }}
                      </el-button>
                    </div>
                    <el-table
                            :data="roleDetail"
                            size="mini"
                            style="width: 100%"
                            :highlight-current-row="true"
                            @row-click="selectRow"
                            :show-header="false">
                      <el-table-column prop="groupname" label="" width="180"></el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="width:70%">
            <div>
              <el-divider content-position="left">{{$t('getapi[3547]')}}</el-divider>
            </div>
            <div style="height:600px;overflow: scroll" id="searchtree-eletree">
              <el-tree ref="tree"
                       class="filter-tree"
                       :data="detailDataTree"
                       :props="detailDefaultProps"
                       show-checkbox
                       check-strictly
                       highlight-current
                       node-key="id"
                       :default-checked-keys="defaultchecked"
                       :default-expanded-keys="defaultEexpandedkeys"
                       @check="handleCheck"></el-tree>
            </div>
          </div>
        </div>
        <!--<div style="width:100%;display: flex;">
          <div style="width:30%">
            <div v-if="authority_save">
              <el-card class="box-card" style="height:100%">
                <el-button type="text" size="small" @click="showRole">{{
                  $t('getapi[3553]') }}
                </el-button>
                <el-button type="text" size="small" @click="deleteRole">{{
                  $t('getapi[3554]') }}
                </el-button>
              </el-card>
            </div>
          </div>
          <div style="width:70%">
            <div v-if="authority_save">
              <el-card class="box-card" style="height:100%">
                <el-button type="text" size="small" @click="saveRole">{{
                  $t('getapi[3556]') }}
                </el-button>
              </el-card>
            </div>
          </div>
        </div>-->
      </div>
      <span slot="footer" class="dialog-footer">
				<el-button @click="isShowDetail = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="save">{{$t('getapi[937]')}}</el-button>
			</span>
    </el-dialog>

    <selector :isVisible="false" :isSplitPage=true
              :postUrl="'/webdoc/doc/GetDocRoleList'" @callback="getrole" ref="role"></selector>

    <serce :isVisible="isVisible" queryData="FrmUserPerShowViewInfo" ref="ser" @getser="serclick"></serce>
  </div>
</template>
<script>
  import Sortable from 'sortablejs';
  import Common from "@/components/Common";
  import Array from "@/components/Array";
  import CommonHeader from "@/components/CommonHeader";
  export default {
    name: "docemployee",
      computed: {
          tableHeight(){
              return this.$windowSize.tableHeight-30
          }
      },
    data() {
      return {
          nodeid:'',
          dataNode:[],
          dataSet:[],
          loading: false,
          selectData: [],
          isShowDetail: false,
          dataDetail:[],
          roleDetail:[],
          defaultEexpandedkeys:[],
          defaultchecked:[],
          detailDataTree:[],
          detailDefaultProps: {
              children: 'Children',
              label: 'node_name',
              father_node_id:"father_node_id",
              node_id:"node_id",
              id:"id",
              ischeck:'ischeck',
              visiable:'visiable'
          },
          filterText:'',
          selectrow:{},
          userInfo:{},
          queryData: [], // 查询数组
          isVisible: false,
      }
    },
    beforeDestroy(){
        if (this.sortable1) {
            this.sortable1.destroy();
        }
    },
    mounted: function () {
      let that = this
      that.$limits.dragControllerDiv();
      that.getNode();
    },
    methods: {
        search() {
            let that = this;
            that.isVisible = true;
            that.$refs.ser.clearInput(that.isVisible, 'FrmUserPerShowViewInfo');
        },
        //获取查询条件
        serclick(val) {
            let that = this
            this.queryData = val;
            that.selectData = [];
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                Param: datac
            };
            that.loading = true
            that.$http.urlpost('/webdoc/doc/GetDocEmployeeDataList', parm, function (res) {
                if (res.Success == 1) {
                    that.dataSet = res.DataContent;
                    that.authority();
                }
                that.loading = false
            });
        },
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1073]"),this.$t("getapi[79]"));
        },
        authority(){
            let that = this
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetButtonEnable('save,search,refresh');
        },
        leftt(e) {
            var left = document.getElementsByClassName("left");
            var mid = document.getElementsByClassName("mid");
            var Box = document.getElementsByClassName("Boxs");
            let bw = Box[0].clientWidth;
            if (e == 1) {
                left[0].style.width = "0px";
                mid[0].style.width = bw - 10 + "px";
            } else {
                left[0].style.width = bw - 50 + "px";
                mid[0].style.width = "0px";
            }
        },
        tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
            return 'drag-btn'
        },
        getNode(){
            let that = this
            that.$http.urlpost('/webdoc/doc/GetDocDeptLists', '', function (res) {
                if (res.Success == 1) {
                    that.dataNode = res.DataContent;
                    that.authority();
                }
            });
        },
        getDetail(row){
            let that = this
            that.selectData = [];
            let parm = {
                deptid: row.num,
                Param: []
            }
            that.loading = true
            that.$http.urlpost('/webdoc/doc/GetDocEmployeeDataList', parm, function (res) {
                if (res.Success == 1) {
                    that.dataSet = res.DataContent;
                    that.nodeid = row.node_id;
                    that.authority();
                }
                that.loading = false
            });
        },
        reflash(){
            let that = this
            that.getInfo()
        },
        getInfo(){
            let that = this
            if(that.nodeid == ''){
                return
            }
            that.selectData = [];
            let parm = {
                deptid: that.nodeid,
                Param: []
            }
            that.loading = true
            that.$http.urlpost('/webdoc/doc/GetDocEmployeeDataList', parm, function (res) {
                if (res.Success == 1) {
                    that.dataSet = res.DataContent;
                    that.authority();
                }
                that.loading = false
            });
        },
        save(){
            let that = this
            let parm = {
                IsAdd: 1,
                IsReset: 0,
                UserInfo: that.userInfo,
                RoleGroupList: that.roleDetail,
                Lists: that.detailDataTree
            }
            that.$http.urlpost('/webdoc/doc/SaveDocUserAuthorityList', parm, function (res) {
                if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    that.isShowDetail = false
                }
            });
        },
        handleSelectionChange(val) {
            let that = this;
            that.selectData = val;
        },
        batchDel(){
            let that = this
            this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning'
            })
                .then(() => {
                    if(that.selectData[0].auditid == ''){
                        that.dataSet.splice(that.selectData[0].index, 1)
                    } else {
                        let parm = {
                            Code: that.selectData[0].auditid,
                            LangType: that.$processdata.getLang()
                        }
                        that.$http.urlpost('/webdoc/doc/DelDocApprovalSet', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getInfo();
                            }
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: that.$t('getapi[8574]')
                    });
                });
        },
        edit(){
            let that = this
            that.isShowDetail = true
            that.userInfo = {
                UserNum:that.selectData[0].usernum
            }
            let parm = {
                UserNum: that.selectData[0].usernum
            }
            that.$http.urlpost('/webdoc/doc/GetUserRoleAuthorityList', parm, function (res) {
                if (res.Success == 1) {
                    that.dataDetail = that.selectData[0]
                    that.roleDetail = res.DataContent.RoleGroupList
                    that.detailDataTree = res.DataContent.AuthorityList
                    that.tickMenuIdFilter().filter(that.detailDataTree);
                }
            });
        },
        tickMenuIdFilter: function() {
            let that = this
            that.defaultchecked = [];
            let parentPerIDArr = []
            let getTickMenuId = function(obj) {
                if (undefined == obj || null == obj || obj.length == 0) {
                    return;
                }
                obj.node_name = ((!that.$limits.fnIsEmpty(obj.field_langid) && !isNaN(obj.field_langid))?(that.$t('getapi['+ obj.field_langid +']')):obj.node_name)
                if (obj.ischeck == true) {
                    that.defaultchecked.push(obj.id);
                }
                if (null != obj.Children && obj.Children.length != 0) {
                    for (let child of obj.Children) {
                        getTickMenuId(child);
                    }
                }
            };
            return {
                filter: function(arr) {
                    if (arr.length == 0) {
                        return false;
                    }
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    that.$refs.tree.setCheckedKeys(that.defaultchecked)
                    return that.defaultchecked;
                }
            };
        },
        handleCheck(data,checked){
            let that = this
            console.log(data)
            console.log(checked)
            let arr = checked.checkedKeys
            let isChecked = false
            for(let i=0;i<arr.length;i++){
                if(arr[i] == data.id){
                    isChecked = true
                    break
                } else {
                    isChecked = false
                }
            }
            if(isChecked == true){
                if(data.Children == null) { // 勾选子节点
                    data.ischeck = true
                    let parentid = data.father_node_id
                    that.recursivetrueSon().filter(that.detailDataTree,parentid)
                } else {
                    that.recursivetrue().filter(data)
                }

                setTimeout(() => {
                    that.tickMenuIdFilter().filter(that.detailDataTree);
                }, 100);
                console.log(that.detailDataTree)
            } else {
                if(data.Children == null) {
                    data.ischeck = false
                    let parentid = data.father_node_id
                    that.recursivetrueCancelSon().filter(that.detailDataTree,parentid)
                } else {
                    that.recursivetrueCancel().filter(data)
                }
                that.tickMenuIdFilter().filter(that.detailDataTree);
            }
        },
        recursivetrue: function(){
            let that = this
            let recursiveArray = function(arr){
                arr.ischeck = true
                if (null != arr.Children && arr.Children.length != 0) {
                    for (let array of arr.Children) {
                        recursiveArray(array)
                    }
                }
            }
            return{
                filter:function(data){
                    if(data.length == 0){
                        return false
                    }
                    data.ischeck = true
                    recursiveArray(data)
                    return that.detailDataTree
                }
            }
        },
        recursivetrueCancel: function(){
            let that = this
            let recursiveArray = function(arr){
                arr.ischeck = false
                if (null != arr.Children && arr.Children.length != 0) {
                    for (let array of arr.Children) {
                        recursiveArray(array)
                    }
                }
            }
            return{
                filter:function(data){
                    if(data.length == 0){
                        return false
                    }
                    data.ischeck = false
                    recursiveArray(data)
                    return that.detailDataTree
                }
            }
        },
        recursivetrueSon:function(){
            let that = this
            let id = ""
            let recursiveArray = function(arr){
                if(null != arr.Children && arr.Children.length != 0 && arr.node_id == id){
                    arr.ischeck= true
                }
                if(null != arr.Children && arr.Children.length != 0){
                    for (let array of arr.Children){
                        recursiveArray(array)
                    }
                }
            }
            return{
                filter:function(data,parentid){
                    id = parentid
                    if(data.length == 0){
                        return
                    }
                    for (let rootMenu of data) {
                        recursiveArray(rootMenu)
                    }
                    return that.detailDataTree
                }
            }
        },
        recursivetrueCancelSon:function(){
            let that = this
            let id = ""
            let recursiveArray = function(arr){
                if(null != arr.Children && arr.Children.length != 0 && arr.node_id == id){
                    arr.ischeck= false
                    for(let i = 0;i<arr.Children.length;i++){
                        if(arr.Children[i].ischeck == true){
                            arr.ischeck = true
                            return
                        }
                    }
                }
                if(null != arr.Children && arr.Children.length != 0){
                    for (let array of arr.Children){
                        recursiveArray(array)
                    }
                }
            }
            return{
                filter:function(data,parentid){
                    id = parentid
                    if(data.length == 0){
                        return
                    }
                    for (let rootMenu of data) {
                        recursiveArray(rootMenu)
                    }
                    return that.detailDataTree
                }
            }
        },
        // 增加角色
        showRole() {
            let that = this
            that.$refs.role.clearInput(true);
        },
        getrole(row){
            let that = this
            console.log(row)
            for(let i = 0;i<that.roleDetail.length;i++){
                if(that.roleDetail[i].groupid == row.groupid){
                    return false
                }
            }
            that.roleDetail = [...that.roleDetail,{
                groupid: row.groupid,
                groupname: row.groupname
            }]
            for(let i = 0;i<that.roleDetail.length;i++){
                if(that.roleDetail[i].groupid != 0){
                    that.mergeTree(that.roleDetail[i].groupid)
                }
            }
        },
        mergeTree(id){
            let that = this
            let parm = {
                Id: id,
                fromname: "",
                LangType: that.$processdata.getLang()
            }
            that.$http.urlpost('/webdoc/doc/GetDocRoleAuthorityList', parm, function (res) {
                if (res.Success == 1) {
                    let data = res.DataContent.RoleList
                    if(that.detailDataTree.length == 0){
                        that.detailDataTree = data
                        that.tickMenuIdFilter().filter(that.detailDataTree);
                    } else {
                        let cacheCheckedData = that.tickMenuIdFilterCheckedData().filter(data);
                        that.appendTree().filter(that.detailDataTree, cacheCheckedData);
                        that.tickMenuIdFilter().filter(that.detailDataTree);
                    }
                }
            });
        },
        // 权限项合并，暂时当前项
        tickMenuIdFilterCheckedData: function() {
            let that = this
            let checkedData = []
            let getTickMenuId = function(obj) {
                if (undefined == obj || null == obj || obj.length == 0) {
                    return;
                }
                if (obj.ischeck == true) {
                    checkedData.push(obj.id);
                }
                if (null != obj.Children && obj.Children.length != 0) {
                    for (let child of obj.Children) {
                        getTickMenuId(child);
                    }
                }
            };
            return {
                filter: function(arr) {
                    if (arr.length == 0) {
                        return false;
                    }
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return checkedData;
                }
            };
        },
        // 合并权限
        appendTree:function() {
            let that = this
            let arr = []
            let getTickMenuId = function(obj) {
                if (undefined == obj || null == obj || obj.length == 0) {
                    return;
                }
                for(let i = 0;i<arr.length;i++){
                    if(obj.id == arr[i]){
                        obj.ischeck = true
                    }
                }
                if (null != obj.Children && obj.Children.length != 0) {
                    for (let child of obj.Children) {
                        getTickMenuId(child);
                    }
                }
            };
            return {
                filter: function(arr1, arrCheckedData) {
                    arr = arrCheckedData
                    if (arr.length == 0) {
                        return false;
                    }
                    for (let rootMenu of arr1) {
                        getTickMenuId(rootMenu, arrCheckedData);
                    }
                }
            };
        },
        selectRow(row){
            let that = this
            that.selectrow = row
        },
        deleteRole(){
            let that = this
            if(that.selectrow.groupid == 0){
                return
            }
            for(let i = 0;i<that.roleDetail.length;i++){
                if(that.selectrow.groupid == that.roleDetail[i].groupid){
                    that.roleDetail.splice(i,1)
                }
            }
            that.roleDetail = [...that.roleDetail]
            if(that.roleDetail.length == 0){
                that.clearTree().filter(that.detailDataTree);
                that.tickMenuIdFilter().filter(that.detailDataTree);
            } else {
                that.detailDataTree = []
                for(let i = 0;i<that.roleDetail.length;i++){
                    if(that.roleDetail[i].groupid != 0){
                        that.mergeTree(that.roleDetail[i].groupid)
                    }
                }
            }
        },
        // 解析数组
        clearTree: function() {
            let that = this
            let getTickMenuId = function(obj) {
                if (undefined == obj || null == obj || obj.length == 0) {
                    return;
                }
                obj.ischeck = false
                if (null != obj.Children && obj.Children.length != 0) {
                    for (let child of obj.Children) {
                        getTickMenuId(child);
                    }
                }
            };
            return {
                filter: function(arr) {
                    if (arr.length == 0) {
                        return false;
                    }
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return that.detailDataTree;
                }
            };
        },
    }
  };
</script>

<style scoped lang="less">
  table {
    border-collapse: separate;
    border-spacing: 0px 5px;
    td {
      padding-left: 3px;
      white-space: pre;
    }
  }
  .el-form--inline .el-form-item {
    display: flex;
  }

  .tb-edit .el-input {
    display: none
  }

  .tb-edit .current-row .el-input {
    display: block;
  }

  .tb-edit .current-row .el-input + span {
    display: none
  }

  .el-table .hidden-row {
    display: none;
  }
  /deep/.el-scrollbar__wrap{
    overflow: scroll;
    overflow-y: scroll;
  }
</style>